import { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import type { DataType, SelectFieldStatisticsResponse } from '../../../common/types.tsx';
import messages from './messages.tsx';

export const useTransformer = () => {
	const { formatMessage } = useIntl();

	const transform = useCallback(
		(data: SelectFieldStatisticsResponse): DataType[] => {
			return [
				...Object.entries(data.slices).map(([label, value]) => ({ label, value })),
				...(data.other > 0
					? [{ label: formatMessage(messages.otherLabel), value: data.other }]
					: []),
			];
		},
		[formatMessage],
	);

	return { transform };
};
